import { Link } from '@/compat/react-router-dom';
import { HOTEL_CATALOG_NOTE } from '@/shared/hotelPolicyCopy';

const HotelSellClosedNotice = ({ message }) => (
  <div className="alert alert-light border mb-4" role="status">
    <p className="mb-2">{message}</p>
    <p className="mb-2">{HOTEL_CATALOG_NOTE}</p>
    <p className="mb-0">
      <Link to="/hotels">Browse the hotel catalogue</Link>
    </p>
  </div>
);

export default HotelSellClosedNotice;
